import PropTypes from "prop-types"

export const MBooking = PropTypes.shape({
  amount_of_adults:          PropTypes.number.isRequired,   // amount_of_adults: 1
  arrival:                   PropTypes.string.isRequired,   // arrival: "2018-12-16"
  departure:                 PropTypes.string.isRequired,   // departure: "2018-12-18"
  destination:               PropTypes.string.isRequired,   // destination: "Las Vegas, NV"
  first_name:                PropTypes.string.isRequired,   // first_name: "Clay"
  id:                        PropTypes.number.isRequired,   // id: null
  last_name:                 PropTypes.string.isRequired,   // last_name: "Unicorn"
  property:                  PropTypes.string.isRequired,   // property: "Westgate Las Vegas Resort & Casino"
  package_price:             PropTypes.number.isRequired,
  status:                    PropTypes.string.isRequired,
  tour_confirmation_code:    PropTypes.string,
  scheduled_tour_date:       PropTypes.string,
  scheduled_tour_time:       PropTypes.string,
  preview_center:            PropTypes.string,
  lodging_confirmation_code: PropTypes.string,
  // Cancellation Policies
})
